import wysiwyg from './wysiwyg';

export default wysiwyg;
